export default "__VITE_ASSET__CFLb0DQh__"